import { gql } from "@apollo/client";
import { PageDataFragment } from "../PageData";

export const RHTVPageFieldsFragment = gql`
  ${PageDataFragment}
  fragment RhtvPageFields on Page {
    ...PageData
    rhtvPageContent {
      headline
      subhead
      videoTrayOpen
      videoTrayClose
      soundPopupHeadlineOverride
      rrtvAriaLabels {
        sectionLabel
        channelTitle
        videoPlaylist
        channelVideos
        playVideo
        videoPlaying
      }
    }
  }
`;
